export const CONTENTFUL_ASSETS = {
  HERO_BACKGROUND: 'https://images.ctfassets.net/xj2phibuyt2r/6VnEppDlyRrwlyEdXoHzmD/cd7a998bd556223f3fc0b1f79cbef4f3/hero-background-min.jpg',
  CONTACT_IMAGE: 'https://images.ctfassets.net/xj2phibuyt2r/47NTHFZRJ5LfbbHxgkkLe0/24040deddb79ca85f635e20f3a7de636/contact.jpg',
  GRADIENT_DESKTOP: 'https://images.ctfassets.net/xj2phibuyt2r/edS9sFpqkXInutLqL1JjV/581612241406212da7a79255b05e6f97/gradient-green-desktop-min.png',
  GRADIENT_MOBILE: 'https://images.ctfassets.net/xj2phibuyt2r/7BUrH354CmDzA2Li4mMpDI/f4e3ba317a53bfe00635802f8376b566/gradient-green-mobile-min.png',
}
